import {v4 as uuidv4} from "uuid";
import {create} from "zustand";

export type ToastItem = {
	id: string;
	message: string;
	type: "info" | "success" | "error";
	timer: NodeJS.Timeout;
};

type ToastState = {
	toasts: ToastItem[];
	addToast: (message: string, type: "info" | "success" | "error") => void;
	removeToast: (id: string) => void;
};

const MAX_TOAST_COUNT = 5;
const DEPLAY_TIME = 3000;

export const useToastStore = create<ToastState>((_set, _get) => ({
	toasts: [],
	addToast: (message, type) => {
		const id = uuidv4();

		const timer = setTimeout(() => {
			_get().removeToast(id);
		}, DEPLAY_TIME);

		_set((state) => ({
			toasts: [...state.toasts, {id, message, type, timer}].slice(-MAX_TOAST_COUNT)
		}));
	},
	removeToast: (id) => {
		const toast = _get().toasts.find((toast) => toast.id === id);

		if (toast) {
			clearTimeout(toast.timer);
		}

		_set((state) => ({toasts: state.toasts.filter((toast) => toast.id !== id)}));
	}
}));